export default __webpack_public_path__ + "static/media/tick-green.b559988b.svg";